import { state } from './state.ts';

// İstemci olayları: yalnız tarayıcının bildiği hareketler (sayfa görüntüleme,
// duraklatma, takılma, tam ekran…) toplanıp /api/stats/events'e gönderilir.
// Oynatma başlangıcı/bitişi, arama, favori gibi olayları SUNUCU kendi yazar;
// burada tekrar bildirilmez.
//
// Gönderim: kuyruk 10 saniyede bir ya da 20 olayda boşalır; sekme kapanırken
// sendBeacon ile son parti gider. Oturum yoksa olay tutulmaz.

export interface ClientEvent {
  type: string;
  at: number;
  playbackId?: string | null;
  kind?: string | null;
  itemKey?: string | null;
  title?: string | null;
  quality?: number | null;
  value?: number | null;
  data?: Record<string, string | number | boolean>;
}

const FLUSH_MS = 10_000;
const FLUSH_AT = 20;
const ENDPOINT = '/api/stats/events';

let queue: ClientEvent[] = [];
let timer: number | null = null;

export function track(type: string, fields: Omit<ClientEvent, 'type' | 'at'> = {}): void {
  if (!state.session) return;
  queue.push({ type, at: Date.now(), ...fields });
  if (queue.length >= FLUSH_AT) { void flush(); return; }
  if (timer === null) timer = window.setTimeout(() => void flush(), FLUSH_MS);
}

export async function flush(): Promise<void> {
  if (timer !== null) { clearTimeout(timer); timer = null; }
  if (!queue.length) return;
  const batch = queue;
  queue = [];
  try {
    await fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      keepalive: true,
      body: JSON.stringify({ events: batch }),
    });
  } catch {
    // Ağ yoksa parti düşer; istatistik uğruna yeniden deneme trafiği üretmiyoruz.
  }
}

/** Sekme kapanırken: fetch iptal olabilir, sendBeacon kalır. */
function flushOnHide(): void {
  if (timer !== null) { clearTimeout(timer); timer = null; }
  if (!queue.length) return;
  const body = JSON.stringify({ events: queue });
  queue = [];
  try {
    if (!navigator.sendBeacon?.(ENDPOINT, new Blob([body], { type: 'application/json' }))) {
      void fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', keepalive: true, body });
    }
  } catch { /* beacon yok */ }
}

let lastView = '';

/** Rota değişimi. Aynı yola art arda gelinirse (yeniden çizim) ikinci kez sayılmaz. */
export function trackView(path: string): void {
  if (path === lastView) return;
  lastView = path;
  track('view', { data: { path: path.slice(0, 200) } });
}

export function startStats(): void {
  window.addEventListener('pagehide', flushOnHide);
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') flushOnHide(); });
}
